import { Component, ChangeDetectionStrategy } from '@angular/core';


@Component({
	selector: 'common-spinner',
	standalone: true,
	templateUrl: './common-spinner.widget.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: ['./common-spinner.widget.scss']
})
export class CommonSpinnerWidget {
}